<template>
<v-card outlined>
  <v-card-actions>
    <strong class="subtitle-1"><i>Promotional Discounts</i></strong>
  </v-card-actions>
  <v-divider></v-divider>
  <v-card-text>
    <v-simple-table>
      <tbody>
        <tr v-for="promo in promos" :key="promo.uid" :class="promo.$softDelete ? 'error lighten-2' : ''">
          <td>
            <v-text-field v-model="promo.name" label="Display Name"></v-text-field>
          </td>
          <td>
            <v-text-field v-model="promo.imperative_name" label="Imperative Name"></v-text-field>
          </td>
          <td>
            <v-text-field v-model="promo.min_price" label="Minimum Price"></v-text-field>
          </td>
          <td>
            <v-text-field v-model="promo.discount" label="Discount"></v-text-field>
          </td>
          <td>
            <v-text-field v-model="promo.min_test_count" label="Minimum Test Count"></v-text-field>
          </td>
          <td>
            <v-select v-model="promo.allowed_tests" :items="testTypes" label="Allowed Tests" item-text="name" item-value="uuid" multiple></v-select>
          </td>
          <td>
            <v-select v-model="promo.allowed_categories" :items="categories" label="Allowed Categories" item-text="name" item-value="uuid" multiple></v-select>
          </td>
          <td>
            <v-select v-model="promo.has_tests" :items="testTypes" label="Has Tests" item-text="name" item-value="uuid" multiple></v-select>
          </td>
          <td class="text-center">
            <v-btn v-if="!promo.$softDelete" color="error" outlined @click="remove(promo)" small shaped ><v-icon>remove</v-icon></v-btn>
            <v-tooltip v-else bottom>
              <template v-slot:activator="{on}">
                <v-btn v-on="on" outlined @click="promo.$softDelete = false" small shaped ><v-icon>undo</v-icon></v-btn>
              </template>
              <span>Undo deletion</span>
            </v-tooltip>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
    <v-row justify="center">
      <v-btn class="success" @click="add" dark><v-icon>add</v-icon> Create Promo</v-btn>
    </v-row>
  </v-card-text>
</v-card>
</template>

<script>
export default {
    name: "BillingPromo",
    components: {},
    data: () => ({
      loading: false,
      loadingError: false,
      promos: []
    }),
    watch:{
      promos:{
        deep: true,
        handler(v){
          this.originalPromos = v;
        }
      }
    },
    computed:{
      testTypes(){
        return this.$store.$db().model('sampleTestTypes').all()
      },
      categories(){
        return this.$store.$db().model('sampleCertTypeCategories').all()
      },
      originalPromos:{
        get(){
          return this.$store.$db().model('billingPromotions').all()
        },
        set(v){
          this.$store.$db().model('billingPromotions').insertOrUpdate({data: v});
        }
      }
    },
    mounted(){
        this.load();
    },
    methods: {
      async load(){
        this.loading = true;
        this.loadingError = false;
        await this.$store.$db().model('billingPromotions').load();
        this.reset();
      },
      add(){
        this.$store.$db().model('billingPromotions').add();
        this.reset();
      },
      remove(item){
        if(item.$isNew){
          item.$delete();
          this.reset();
        }else{
          item.$softDelete = true;
        }
      },
      reset(){
        this.promos = this.originalPromos
      }
    }
}
</script>

<style scoped>

</style>
